import { format, parse } from "date-fns";

/**
 * Function transforming a given Date (only its time part is used) to a string
 * in hour format (HH:mm). Used to parse absence request form data to BE friendly format.
 * @param {Date} time - a Date object holding the selected hour and minute.
 * @returns {string} string with hour format, e.g. "12:30".
 */
export const formatTimeToApiString = (time: Date) => format(time, "HH:mm");

/**
 * Function transforming a given string in hour format (00:00:00) to a Date object.
 * Used to parse absence request data from API to a value usable by the TimePicker in the form.
 * @param {string} hour - string in format HH:mm:ss
 * @returns {Date | null} a Date object with the parsed hour and minute set, or null when not provided.
 */
export const parseApiTimeStringToDate = (hour?: string) => {
  if (typeof hour !== "string") return null;

  return parse(hour, "HH:mm:ss", new Date());
};
